import { computed } from 'vue';

export function cartItemDto(item) {

    const id = computed(() => {
        if (item && item.id && item.id.length > 0) {
            return item.id;
        }
        return '';
    });

    const productImage = computed(() => {
        if (item?.sku?.image?.src?.length) return item.sku.image.src;
        else if (item?.product?.images?.length) return item.product.images[0].src;
        else return "/images/no-image.jpeg";
    });

    const title = computed(() => {
        if (item?.product?.name) {
            return item.product.name;
        }
        return '';
    });

    const productAttributes = computed(() => {
        if (item?.sku?.attributes?.length) {
            return item.sku.attributes.map(attr => `${attr.name}: ${attr.option.toUpperCase()}`).join(', ');
        }
        return '';
    });


    const productSize = computed(() => {
        if (item?.sku?.attributeValues?.length) {
            let size = item.sku.attributeValues.find(a => a.optionDisplayLabel == "Size" || a.optionDisplayLabel == "size");
            return size.displayLabel;
        }
        return '';
    });

    const productColor = computed(() => {
        if (item?.sku?.attributeValues?.length) {
            let color = item.sku.attributeValues.find(a => a.optionDisplayLabel == "Color" || a.optionDisplayLabel == "color");
            return color.displayLabel;
        }
        return '';
    });

    const price = computed(() => {
        if(item?.sku?.sale_price && item?.sku?.regular_price && item?.sku?.sale_price < item?.sku?.regular_price) return (Number(item.sku.sale_price)).toFixed(2);
        else return (Number(item.sku.price)).toFixed(2);
    });

    const quantity = computed(() =>  item.quantity ?? 0);

    const subtotal = computed(() => (Number(price.value) * Number(quantity.value)).toFixed(2));


    return {
        id,
        productImage,
        title,
        productAttributes,
        productSize,
        productColor,
        price,
        quantity,
        subtotal,
    };
}
